<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="60rem" title="检治项目编辑" @close="cancel">
    <el-form :model="examineItem" :rules="comRules" ref="editor" label-width="6rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-input type="text" placeholder="请输入名称" size="small" v-model.trim="examineItem.name" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="编码" prop="code">
            <el-input type="text" placeholder="请输入编码" size="small" v-model.trim="examineItem.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="助记码" prop="shortCode">
            <el-input type="text" placeholder="请输入助记符" size="small" v-model="examineItem.shortCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目源" prop="srcType">
            <hic-dict-selector dict-type="ExamineSrcType" is-enum v-model="examineItem.srcType" />
            <!-- <el-select style="width: 100%" v-model="examineItem.srcType" size="small" clearable placeholder="请选择">
              <el-option v-for="item in Enum.ExamineSrcType" :key="item" :label="item" :value="item"></el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="源项目" prop="srcCode">
            
            <el-select style="width: 100%" v-loading="typeLoding" size="small" v-model="examineItem.srcCode" placeholder="请先选择项目源" filterable>
              <el-option v-for="(item, index) in srcItem" :key="index" :label="item.name" :value="item.code"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="执行科室" prop="execDeptCode">
            <hic-dict-selector dict-type="Dept" v-model="examineItem.execDeptCode" />

          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="标准类型" prop="type">
            <hic-dict-selector dict-type="examineStandardType" is-enum v-model="examineItem.type" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检查部位" prop="parts">

            <hic-dict-selector dict-type="Parts"  v-model="examineItem.parts" />

     
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请类型" prop="appType">
            <hic-dict-selector dict-type="AppType"  v-model="examineItem.appType" />


           
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="检治类型" prop="examineType">
            <hic-dict-selector dict-type="ExamineType"  v-model="examineItem.examineType" />
        
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="项目类型" prop="examineItemType">

            <hic-dict-selector dict-type="ExamineItemType"  v-model="examineItem.examineItemType" />


  
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="标本类型" prop="specimenType">

            <hic-dict-selector dict-type="SpecimenType"  v-model="examineItem.specimenType" />

          
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检查方法" prop="checkWay">
            <hic-dict-selector dict-type="CheckWay"  v-model="examineItem.checkWay" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别限制" prop="gender">
            <hic-dict-selector dict-type="Gender"  v-model="examineItem.gender" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="天数" prop="days">
            <el-input type="text" placeholder="请输入天数" size="small" v-model="examineItem.days" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报告时间" prop="reportDelay">
            <el-input type="text" placeholder="请输入取报告时间" size="small" v-model="examineItem.reportDelay" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="备注" prop="memo">
            <el-input type="text" placeholder="请输入备注" size="small" v-model="examineItem.memo" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      examineItem: Object,
    },
    data() {
      return {
        origin: null,
        typeLoding: false,
        condition: {
          pageIndexOnView: 1,
          pageSize: 99999,
        },
        srcItems: {
          standards: [],
          sets: [],
        },
        comRules: {
          code: [
            {
              required: true,
              message: "请输入编码",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请输入名称",
              trigger: "blur",
            },
          ],
          srcType: [
            {
              required: true,
              message: "请选择项目源类型",
              trigger: "blur",
            },
          ],
          srcCode: [
            {
              required: true,
              message: "请输入项目源编码",
              trigger: "blur",
            },
          ],
          shortCode: [
            {
              required: true,
              message: "请输入助记符",
              trigger: "blur",
            },
          ],
          type: [
            {
              required: true,
              message: "请选择标准类型",
              trigger: "change",
            },
          ],
          execDeptCode: [
            {
              required: true,
              message: "请选择执行科室",
              trigger: "change",
            },
          ],
        },
        disabledSave: false,
        synDisabledSave: false,
        deptFilterKey: null,
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
      srcItem() {
        if (this.examineItem.srcType == this.Enum.ExamineSrcType.标准编码) {
          return this.srcItems.standards;
        } else if (this.examineItem.srcType == this.Enum.ExamineSrcType.检治集) {
          return this.srcItems.sets;
        } else {
          return [];
        }
      },
    },
    created() {
      this.typeLoding = false;
      this.showEditor = true;
      
      api
        .Item.queryStandard(this.condition)
        .then((res) => {
          this.srcItems.standards = res.items;
        })
        .catch(() => {})
        .finally(() => {
          this.typeLoding = false;
        });

      api
        .Item.queryExamineSet(this.condition)
        .then((res) => {
          this.srcItems.sets = res.items;
        })
        .catch(() => {})
        .finally(() => {
          this.typeLoding = false;
        });
    },
    methods: {
      open() {},
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      del: function (row, index) {
        let _this = this;
        api.Item.del(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
        });
      },
      save() {
        this.$refs.editor.validate().then((valid) => {
          if (valid) {
            this.disabledSave = true;
            api
              .Item.save(this.examineItem)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("ok");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.disabledSave = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
  .flex {
    display: flex;
    justify-content: center;
  }
</style>
